import { z } from 'zod'

/**
 * Themen für Wissen, das an keinem Showcase hängt: alles über die Firma, die
 * Mutterfirma und das Lab selbst. Die Liste ist bewusst kurz und fest — sie
 * ordnet die Einträge im Admin und steht dem Modell als Überschrift vor jedem
 * Abschnitt („Just 4 Fashion (J4F) — Geschichte"), damit ein Treffer auch
 * ohne den Rest des Dokuments sagt, wovon er handelt.
 */
export const KNOWLEDGE_TOPICS = [
  { id: 'j4f', label: 'Just 4 Fashion (J4F)', hint: 'Was die Firma tut, für wen, seit wann' },
  { id: 'j4p', label: 'Just 4 People (j4p)', hint: 'Die Mutterfirma und die Gruppe' },
  { id: 'visionlab', label: 'J4F VisionLab', hint: 'Idee, Konzept, was Besucher hier erleben' },
  { id: 'team', label: 'Team & Ansprechpartner', hint: 'Wer wofür zuständig ist' },
  { id: 'besuch', label: 'Besuch & Anfahrt', hint: 'Adresse, Öffnungszeiten, Parken, Termine' },
  { id: 'sonstiges', label: 'Sonstiges', hint: 'Alles, was in kein anderes Thema passt' },
] as const

export const knowledgeTopicSchema = z.enum(
  KNOWLEDGE_TOPICS.map((t) => t.id) as [KnowledgeTopicId, ...KnowledgeTopicId[]],
)
export type KnowledgeTopicId = (typeof KNOWLEDGE_TOPICS)[number]['id']

export function knowledgeTopicLabel(id: string | null | undefined): string {
  return KNOWLEDGE_TOPICS.find((t) => t.id === id)?.label ?? 'Sonstiges'
}

/** Was das Admin beim Anlegen oder Ändern eines Texteintrags schickt. */
export const knowledgeTextInputSchema = z.object({
  title: z.string().trim().min(1, 'Titel fehlt').max(200),
  topic: knowledgeTopicSchema,
  body: z.string().trim().min(1, 'Text fehlt').max(200_000),
})
export type KnowledgeTextInput = z.infer<typeof knowledgeTextInputSchema>

/**
 * Obergrenze für das Grundwissen, das in jedem Prompt steht. Es kostet bei
 * jeder Antwort Token und Aufmerksamkeit; was länger ist, gehört als Eintrag
 * in die Wissensbasis, wo K4ia gezielt nachschlägt.
 */
export const KNOWLEDGE_FACTS_MAX_CHARS = 4000

/** `source` eines Dokuments, dessen Text im Admin getippt wurde (statt Datei oder Adresse). */
export const TEXT_SOURCE = 'text'
